import React, { FC, useCallback } from "react";

import { FacebookPageQuestionStep, FacebookPageQuestionStepProps } from "../../components/V3/FacebookPageQuestionStep";

import { OnboardingProps } from "../../models";

export interface FacebookPageQuestionStepContainerProps
    extends Pick<FacebookPageQuestionStepProps, "aside" | "style" | "className"> {
    initialProps?: OnboardingProps;
    onNext(props: OnboardingProps): void;
    onBack?(): void;
}

export const FacebookPageQuestionStepContainer: FC<FacebookPageQuestionStepContainerProps> = (props) => {
    const { initialProps, onNext, onBack } = props;

    const handleFacebookPage = useCallback(
        (hasFacebookPage: boolean, value?: string) => {
            console.log("Facebook page selected:", hasFacebookPage, value);

            onNext({
                ...initialProps,
                beta: {
                    ...initialProps?.beta,
                    onboarding: {
                        ...initialProps?.beta?.onboarding,
                        hasSocial: hasFacebookPage,
                        socialSite: value,
                    },
                },
            });
        },
        [initialProps, onNext]
    );

    const handleBack = useCallback(() => {
        console.log("Back button clicked");

        if (typeof onBack === "function") {
            onBack();
        }
    }, [onBack]);

    return <FacebookPageQuestionStep {...props} onNext={handleFacebookPage} onBack={handleBack} />;
};
